import {
  initial_cost,
  annual_bill_savings,
  simple_payback,
  emission_savings,
  on_bill_cost_ratio,
  kwh_savings,
  therms_savings,
  lifecycle_savings,
  compliance_margin,
  tdv_benefit_to_cost_ratio,
  baseline_fuel_type,
  forecast_units,
  forecast_emissions_savings,
  forecast_kwh_savings,
  forecast_therms_savings,
  forecast_lifecycle_savings,
  forecast_initial_cost,
  tdv2022_benefit_to_cost_ratio,
  energy_savings_combined,
} from './columns'

export default {
  existingBuildings: {
    key: 'existingBuildings',
    studyType: 'Existing Buildings',
    columnGroups: [
      {
        order: 0,
        key: "fixed_columns",
        title: 'Benefit/Cost Ratios',
        columns: [
          on_bill_cost_ratio(),
          simple_payback(),
          tdv2022_benefit_to_cost_ratio(),
        ],
        hasHelper: {
          type: 'helper',
          id: 23
        }
      },
      {
        order: 1,
        key: "per_home_results",
        title: 'Per Home Results',
        columns: [
          initial_cost(),
          annual_bill_savings(),
          emission_savings(),
          lifecycle_savings(),
          kwh_savings(),
          therms_savings(),
          energy_savings_combined(),
        ],
        hasHelper: {
          type: 'helper',
          id: 24
        }
      },
      {
        order: 2,
        key: "city_wide_impact",
        title: 'Wide Impact',
        columns: [
          forecast_units(),
          forecast_initial_cost(),
          forecast_emissions_savings(),
          forecast_lifecycle_savings(),
          forecast_kwh_savings(),
          forecast_therms_savings(),
        ],
        hasHelper: {
          type: 'helper',
          id: 25
        }
      },
    ]
  },
  newBuildings: {
    key: 'newBuildings',
    studyType: 'New Buildings',
    columnGroups: [
      {
        order: 0,
        key: "fixed_columns",
        title: 'Cost-Effectiveness',
        columns: [
          simple_payback(),
          on_bill_cost_ratio(),
          tdv_benefit_to_cost_ratio(),
          tdv2022_benefit_to_cost_ratio(),
        ],
        hasHelper: {
          type: 'helper',
          id: 23
        }
      },
      {
        order: 2,
        key: "per_home_results",
        title: 'Per Home Results',
        columns: [
          initial_cost(),
          annual_bill_savings(),
          emission_savings(),
          lifecycle_savings(),
          kwh_savings(),
          therms_savings(),
          baseline_fuel_type(),
          compliance_margin(),
          energy_savings_combined(),
        ],
        hasHelper: {
          type: 'helper',
          id: 24
        }
      }
    ]
  }
}